import React from 'react';

const TraditionAndInnovation = () => {
  return (
    <div className="bg-[#EDEDED] pt-10 mb-[120px]">
      <h1 className="pb-10 px-5 max-w-[1200px] mx-auto text-center text-[#1D1D1F] text-[32px] sm:text-[50px] md:text-[70px] lg:text-[86.4px] leading-[40px] sm:leading-[60px] md:leading-[90px] lg:leading-[130px] font-normal libre-baskerville">
        A dialogue between tradition and innovation
      </h1>
      <div className="w-full h-[610px]">
        <img
          src="/assets/tradition-and-innovation-bg.webp"
          alt="tradition-and-innovation"
          className="w-full object-cover h-full bg-bottom"
        />
      </div>
    </div>
  );
};

export default TraditionAndInnovation;
